import { z } from 'zod';
import type { CrmKind } from './CrmRecordLayout';

export const crmFieldsSchema = z.object({
  tipo: z.enum(['persona_fisica', 'azienda']),
  nome: z.string().trim().max(255), cognome: z.string().trim().max(255), ragione_sociale: z.string().trim().max(255), referente_interno: z.string().trim().max(255),
  email: z.string().trim().email('Email non valida').or(z.literal('')), telefono: z.string().trim(), pec: z.string().trim().email('PEC non valida').or(z.literal('')),
  codice_fiscale: z.string().trim().max(16), partita_iva: z.string().trim().max(11), codice_destinatario: z.string().trim().max(7),
  indirizzo: z.string(), citta: z.string(), provincia: z.string().max(2), cap: z.string().max(5), note: z.string(),
  privacy: z.enum(['SI', 'NO']), consenso_marketing: z.enum(['SI', 'NO']), consenso_terzi: z.enum(['SI', 'NO']), consenso_profilazione: z.enum(['SI', 'NO']),
  filiale_id: z.string(), listino_id: z.string(), canale_ids: z.array(z.string()), agente_id: z.string(),
  stato: z.enum(['nuovo', 'contattato', 'qualificato', 'convertito', 'scartato']), score: z.coerce.number().min(0).max(100),
  source: z.enum(['manual', 'web_form', 'import', 'referral', 'email', 'phone', 'event', 'other']), source_detail: z.string(),
});
export type CrmFormValues = z.infer<typeof crmFieldsSchema>;
export function crmSchema(kind: CrmKind) {
  return crmFieldsSchema.superRefine((data, ctx) => {
    const required = (field: 'nome' | 'cognome' | 'ragione_sociale', message: string) => {
      if (!data[field]) ctx.addIssue({ code: 'custom', path: [field], message });
    };
    if (data.tipo === 'azienda') required('ragione_sociale', 'Ragione sociale obbligatoria');
    else {
      required('nome', 'Nome obbligatorio');
      if (kind === 'lead') required('cognome', 'Cognome obbligatorio');
    }
    if (kind === 'lead' && !data.email && !data.telefono) ctx.addIssue({ code: 'custom', path: ['email'], message: 'Inserisci almeno email o telefono' });
  });
}
